import React, { useState } from "react";
import InnerPopup from "../Popups/InnerPopup";


const NicknameSuccessPopup = ({ onClose }) => {

    return (
        <div className="nickname_modal">
            <InnerPopup onCloseModal={onClose} closeButton={false} >
                <div className="nickname_content_box">

                    <div className="success_message" >
                        <p>
                            {/* Congratulations! */}
                            <br />   NICKNAME ANDA BERHASIL TERDAFTAR!
                        </p>
                    </div >
                </div >
            </InnerPopup >
        </div >
    );
};

export default NicknameSuccessPopup;